import React from 'react'
import { grey } from '@mui/material/colors'
import {
  createTheme,
  ThemeProvider as MUIThemeProvider,
} from '@mui/material/styles'

const theme = createTheme({
  palette: {
    background: {
      default: '#f5f5f5',
    },
    primary: {
      main: '#25A956',
    },
    defaultButton: {
      main: grey[500],
    },
  },
  components: {
    MuiButton: {
      defaultProps: {
        color: 'defaultButton',
      },
      styleOverrides: {
        root: {
          borderRadius: '8px',
          textTransform: 'none',
          boxShadow: 'none !important',
        },
        outlined: {
          padding: '5px 15px',
          color: grey[900],
        },
      },
    },
    MuiTableSortLabel: {
      styleOverrides: {
        icon: {
          opacity: 1,
        },
      },
    },
  },
})

type Props = {
    children: React.ReactNode
}

export function ThemeProvider(props: Props) {
    return <MUIThemeProvider theme={theme}>{props.children}</MUIThemeProvider>
}
